import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import axios from 'axios';

import Projects from './views/Projects.vue';
import Project from './views/Project.vue';
import ProjectManage from './views/ProjectManage.vue';
import Settings from './views/Settings.vue';
import Warehouse from './views/Warehouse.vue';
import Tutorial from './views/Tutorial.vue';
import WorldLogin from '../../../world/spa/components/WorldLogin.vue';

Vue.use(Router);

// Utilizzato per gestire lo scrolling in caso di navigazione back/forward
const scrollBehavior = (to, from, savedPosition) => {
  let position = {};
  if (savedPosition) {
    return savedPosition;
  } else {
    position.x = 0;
    position.y = 0;
    return position;
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_FRONT_BASE_URL,
  scrollBehavior,
  routes: [
    {
      name: 'index',
      path: '/',
      component: Projects,
      // metadati per poter cambiare il titolo della pagina in fase di navigazione mediante router
      meta: {
        title: 'ANM22 Tasks',
        backHref: '',
        section: 'tasks'
      },
    },
    /* Dashboard di progetto */
    {
      name: 'projectDash',
      path: '/project/:id',
      component: Project,
      meta: {
        title: '',
        backHref: '/',
        section: 'tasks'
      }
    },
    /* Nuovo progetto*/
    {
      name: 'newProject',
      path: '/project/new',
      component: ProjectManage,
      meta: {
        title: '',
        backHref: '/',
        section: 'tasks'
      }
    },
    /* Copia progetto */
    {
      name: 'copyProject',
      path: '/project/copy',
      component: ProjectManage,
      meta: {
        title: '',
        backHref: '/',
        section: 'tasks'
      }
    },
    /* Impostazioni progetto */
    {
      name: 'editProject',
      path: '/project/edit/:id',
      component: ProjectManage,
      meta: {
        title: '',
        backHref: '',
        section: 'tasks'
      }
    },
    {
      name: 'settings',
      path: '/settings',
      component: Settings,
      meta: {
        title: 'Settings',
        backHref: '',
        section: 'tasks'
      }
    },
    {
      name: 'warehouse',
      path: '/warehouse',
      component: Warehouse,
      meta: {
        title: 'Warehouse',
        backHref: '',
        section: 'warehouse'
      }
    },
    {
      name: 'login',
      path: '/login',
      component: WorldLogin,
      meta: {
        title: 'Login',
        backHref: '',
        section: 'login'
      }
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter(to, from, next) {
        axios
          .post("auth/logout", {}, { 
            baseURL: process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'spa/controller/',
            withCredentials: true })
          .then(response => {
            router.app.$vlfClearDb();
            store.dispatch('auth/logout');
            next('/login');
          })
          .catch(error => console.log(error));
      }
    },
    {
      name: 'clean',
      path: '/clean',
      redirect(to) {
        router.app.$vlfClearDb();
        return '/';
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
});

router.beforeEach((to, from, next) => {
  router.app.$Progress.start();
  if(to.meta.skipLogin) {
    next();
  } else {
    //Controllo se è stato effettuato il login, uso Axios perchè non posso accedere ancora al plugin
    if (store.state.auth.checkingLogin) {
      axios
        .get("auth/", { 
          baseURL: process.env.VUE_APP_BACK_DOMAIN + process.env.VUE_APP_BACK_BASE_URL + 'spa/controller/',
          withCredentials: true })
        .then(response => {
          if (!response.data.error) {
            //Salvataggio dei dati dell'utente all'interno dello stato
            Promise.all([
              router.app.$vlf('auth').clear(),
              router.app.$vlf('auth').setItem('user', response.data.user),
              store.dispatch("licenses/update", {
                vlf: router.app.$vlf("licenses"),
                objs: response.data.licenses
              })
            ])
            .then(result => {
              store.dispatch('auth/updateUserInfo', { data: response.data.user, app: router.app })
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              store.dispatch('auth/endLoginCheck');
              if(to.fullPath === '/login') {
                next('/');
              } else {
                next();
              }
            });
          } else {
            store.dispatch('auth/endLoginCheck');
            if(to.path === '/login') {
              next();
            } else {
              next('/login?cb='+to.path);
            }
          }
        })
        .catch(error => {
          console.log(error);
          if (!error.status) {
            // Offline -> check local storage
            router.app.$vlf('auth').getItem('user')
            .then(result => {
              return Promise.all([
                store.dispatch('auth/updateUserInfo', { data: result, app: router.app }),
                store.dispatch("licenses/load", router.app.$vlf("licenses"))
              ])
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              store.dispatch('auth/endLoginCheck');
              if(to.fullPath === '/login') {
                next('/');
              } else {
                next();
              }
            });
          }
        });
    } else {
      next();
    }
  }
});

//Nel caso di informazioni statiche, vengono settate qui, altrimenti nei singoli componenti avvengono ulteriori
//elaborazioni
router.afterEach((to, from, next) => {
  document.title = to.meta.title;
  // Modifica l'etichetta dell'headbar
  if(to.path !== '/'){
    store.dispatch('headbar/setHeadbarTitle', to.meta.title);
  } else {
    store.dispatch('headbar/setHeadbarTitle', '');
  }
  // Controllo e setto l'eventuale back href
  store.dispatch('headbar/setBackHref', to.meta.backHref);
  // Setto la voce del menu di navigazione da selezionare
  store.dispatch('menu/setSelected', to.meta.section);
});

export default router;
